export default class Figures {
    constructor({ el }) {
        

        const controls = el.querySelector(".toggle-play-pause")
        const soundControls = el.querySelector(".toggle-sound")
        const video =  el.querySelector("video")

        if (controls && video) {
            controls.addEventListener("click", () => {
                controls.classList.toggle("paused")
                if (controls.classList.contains("paused")) {
                    video.pause()
                } else {
                    video.play()
                }
            })
        }
        // Sound Control
        if (soundControls && video) {
            soundControls.addEventListener("click", () => {
                // Toggle the UI state class
                soundControls.classList.toggle("muted")
                
                // Check if it is currently muted based on the class
                const isMuted = soundControls.classList.contains("muted")
                
                // Apply properties to the video
                video.muted = isMuted
                
                if (!isMuted) {
                    video.volume = 1.0 // Force max volume when unmuting
                }
            })
        }
    }

    dispose() {
    }
}